import { colors } from 'design-system';
import IconProps from './IconProps';
import VectorIcon from './VectorIcon';

const DocumentIcon = ({
  width = 16.81,
  height = 23.54,
  color = colors.madison,
  x,
  y,
}: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height} x={x} y={y}>
    <path
      d="M15.9924 5.75878L11.3299 0.86322C10.8002 0.308942 10.091 -0.000971966 9.34676 -0.000971966L2.80184 
        -0.000976562C1.25426 -0.000976562 0 1.316 0 2.94095L0.000284562 20.5925C0.000284562 22.2175 1.25455 
        23.5345 2.80212 23.5345H14.0092C15.5568 23.5345 16.811 22.2175 16.811 20.5925V7.83651C16.811 7.05507 
        16.5177 6.31039 15.9924 5.75878ZM9.80644 1.56561C10.0024 1.63759 10.1858 1.7424 10.337 1.90112L14.9995 
        6.79668C15.1518 6.95394 15.2525 7.147 15.3182 7.35386H10.5069C10.1216 7.35386 9.80644 7.02289 9.80644 
        6.61837V1.56561ZM15.4101 20.5925C15.4101 21.4034 14.7815 22.0635 14.0092 22.0635H2.80184C2.02958 
        22.0635 1.40092 21.4034 1.40092 20.5925V2.94096C1.40092 2.13009 2.02958 1.46999 2.80184 1.46999H8.40552V6.61837C8.40552 
        7.83652 9.34676 8.82482 10.5069 8.82482H15.4101V20.5925ZM4.20276 12.5022C4.20276 12.9067 4.51797 
        13.2377 4.90322 13.2377H11.9078C12.2931 13.2377 12.6083 12.9067 12.6083 12.5022C12.6083 12.0977 
        12.2931 11.7668 11.9078 11.7668H4.90322C4.51797 11.7668 4.20276 12.0977 4.20276 12.5022ZM11.9078 
        14.7087H4.90322C4.51797 14.7087 4.20276 15.0396 4.20276 15.4442C4.20276 15.8487 4.51797 16.1796 
        4.90322 16.1796H11.9078C12.2947 16.1796 12.6083 15.8503 12.6083 15.4442C12.6083 15.038 12.2931 
        14.7087 11.9078 14.7087ZM11.9078 17.6506H4.90322C4.51797 17.6506 4.20276 17.9816 4.20276 
        18.3861C4.20276 18.7906 4.51797 19.1216 4.90322 19.1216H11.9078C12.2947 19.1216 12.6083 
        18.7923 12.6083 18.3861C12.6083 17.9799 12.2931 17.6506 11.9078 17.6506Z"
      fill={color}
    />
  </VectorIcon>
);

export default DocumentIcon;
